import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { CATEGORIES } from "@/data/catalog";

export const Footer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const sub = (e) => { e.preventDefault(); if (email) { toast.success(t("footer.subscribed")); setEmail(""); } };
  return (
    <footer className="nv-grain bg-black text-white">
      <div className="nv-container grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-4">
          <img src="/brand/icon.png" alt="NINJAVITY" className="h-14 w-14" />
          <h3 className="mt-4 font-display text-2xl font-bold">NINJAVITY</h3>
          <p className="mt-3 max-w-sm text-sm text-white/60">{t("footer.aboutText")}</p>
        </div>
        <div className="md:col-span-2">
          <p className="nv-eyebrow !text-[#c6ff00]">{t("footer.shop")}</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/eshop" className="text-white/70 hover:text-[#c6ff00]">{t("nav.eshop")}</Link></li>
            {CATEGORIES.map((c) => <li key={c.id}><Link to={`/c/${c.id}`} className="text-white/70 hover:text-[#c6ff00]">{t(`nav.${c.id}`)}</Link></li>)}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="nv-eyebrow !text-[#c6ff00]">{t("footer.help")}</p>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li>{t("footer.contact")}</li><li>{t("footer.faq")}</li><li>{t("footer.shippingReturns")}</li><li>{t("footer.privacy")}</li><li>{t("footer.terms")}</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="nv-eyebrow !text-[#c6ff00]">{t("footer.newsletter")}</p>
          <p className="mt-4 text-sm text-white/60">{t("footer.newsletterSub")}</p>
          <form onSubmit={sub} className="mt-4 flex gap-2">
            <input data-testid="newsletter-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@example.com" className="flex-1 rounded-full border border-white/15 bg-white/5 px-5 py-3 text-sm outline-none focus:border-[#c6ff00]" />
            <button data-testid="newsletter-submit" className="nv-btn-lime !px-5"><ArrowRight size={16} /></button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="nv-container flex flex-col items-center justify-between gap-2 py-6 text-xs text-white/40 sm:flex-row">
          <span>© {new Date().getFullYear()} NINJAVITY. {t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
};
